// ============ CALCULATEUR SCORE DE HIGHAM ============
(function() {
  const formContainer = document.getElementById('higham-form');
  if (!formContainer) {
    return; // Pas de calculateur sur cette page
  }

  console.log('🩸 Calculateur score de Higham détecté');

  // Poids de chaque catégorie selon le PBAC / score de Higham
  // (Higham JM, O'Brien PMS, Shaw RW. BJOG 1990 ; valeurs confirmées
  // par de multiples essais cliniques utilisant le PBAC comme critère)
  //
  // NOTE : ces poids correspondent aux serviettes/culottes menstruelles.
  // Le PBAC original attribue un poids différent aux tampons saturés
  // (10 points au lieu de 20). Ce calculateur ne distingue pas les deux,
  // donc le score peut être légèrement surestimé pour une utilisatrice
  // de tampons au stade "très saturé".
  const WEIGHTS = {
    'hig-light': 1,   // Protection légèrement imbibée
    'hig-mod': 5,     // Protection modérément imbibée
    'hig-sat': 20,    // Protection très saturée (serviette/culotte)
    'hig-clots': 1,   // Petit caillot (< 1cm, ~pièce de monnaie)
    'hig-clotl': 5,   // Gros caillot (> 1cm)
    'hig-over': 5     // Débordement / accident (fuite malgré protection)
  };

  const counts = {};
  Object.keys(WEIGHTS).forEach(function(id) { counts[id] = 0; });

  // ========== ATTACHER LES BOUTONS +/- ==========
  // Les boutons n'ont pas d'id : on les récupère via leur position
  // (le bouton "-" précède le span, le bouton "+" le suit)
  Object.keys(WEIGHTS).forEach(function(id) {
    const span = document.getElementById(id);
    if (!span) return;

    const minusBtn = span.previousElementSibling;
    const plusBtn = span.nextElementSibling;

    if (minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (counts[id] > 0) {
          counts[id]--;
          span.textContent = counts[id];
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        counts[id]++;
        span.textContent = counts[id];
      });
    }
  });

  // ========== BOUTON "CALCULER MON SCORE" ==========
  // Cible en priorité un id="hig-calc-btn" si tu l'ajoutes dans le HTML,
  // sinon retombe sur le sibling suivant du formulaire (structure actuelle)
  let calcBtn = document.getElementById('hig-calc-btn');
  if (!calcBtn) {
    calcBtn = formContainer.nextElementSibling;
  }

  const resultBox = document.getElementById('hig-result');
  const scoreValueEl = document.getElementById('hig-score-value');
  const badgeEl = document.getElementById('hig-badge');
  const resultTextEl = document.getElementById('hig-result-text');

  if (!calcBtn || !resultBox || !scoreValueEl || !badgeEl || !resultTextEl) {
    console.warn('⚠️ Calculateur Higham : éléments manquants dans le HTML, vérifie la structure');
    return;
  }

  // ========== CALCUL DU SCORE ==========
  calcBtn.addEventListener('click', function(e) {
    e.preventDefault();

    let score = 0;
    Object.keys(WEIGHTS).forEach(function(id) {
      score += counts[id] * WEIGHTS[id];
    });

    scoreValueEl.textContent = score;

    let badgeColor, badgeText, resultText;

    if (score < 100) {
      badgeColor = '#9CCC65';
      badgeText = 'Dans la fourchette habituelle';
      resultText = "Ton score se situe sous le seuil de 100, généralement utilisé comme repère pour la ménorragie (à titre indicatif, la plupart des femmes se situent entre 30 et 100). Si tu ressens malgré tout une gêne importante au quotidien (fatigue inhabituelle, douleurs invalidantes), n'hésite pas à en parler à ton gynéco ou médecin généraliste, le score de Higham est un indicateur, pas un verdict.";
    } else if (score < 150) {
      badgeColor = '#FF9800';
      badgeText = 'Seuil de ménorragie atteint';
      resultText = "Ton score dépasse 100, le seuil le plus souvent retenu par la littérature médicale pour évoquer une ménorragie (perte de sang estimée à environ 80 ml ou plus sur le cycle). À noter, certaines études utilisent plutôt un seuil de 150, donc ce résultat mérite d'être discuté avec ton gynéco ou médecin généraliste plutôt qu'interprété seul, surtout si tu ressens fatigue, vertiges ou essoufflement.";
    } else {
      badgeColor = '#EF5350';
      badgeText = 'Score élevé';
      resultText = "Ton score est nettement au-dessus des deux seuils utilisés dans la littérature (100 et 150), ce qui suggère des pertes sanguines abondantes. Il est recommandé de consulter dans un délai raisonnable pour un bilan (fer, ferritine, échographie pelvienne), en particulier si tu ressens fatigue intense, vertiges ou pâleur, des signes possibles d'anémie liée à la perte de fer.";
    }

    badgeEl.style.background = badgeColor;
    badgeEl.textContent = badgeText;
    resultTextEl.textContent = resultText;

    resultBox.style.display = 'block';
    resultBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  console.log('✅ Calculateur Higham initialisé');
})();